import z from "zod";
import { QuantitySchema } from "./Quantity";

export const TicketQuantitySchema = z.union([
  z.object({ type: z.literal("infinite") }),
  z.object({ type: z.literal("limited"), quantity: QuantitySchema }),
]);
export type TicketQuantity = z.infer<typeof TicketQuantitySchema>;

export const TicketProductIdSchema = z.string();
export const TicketProductSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("free"),
    quantity: TicketQuantitySchema,
  }),
  z.object({
    type: z.literal("paid-single"),
    id: TicketProductIdSchema.optional(),
    price: z.number().min(1),
    quantity: TicketQuantitySchema,
  }),
]);

export type TicketProduct = z.infer<typeof TicketProductSchema>;
